
import React,{Fragment, useEffect,useRef,useState} from 'react'
import {getContentPath} from  'system/AssetManager'
// import {fetchCMSJSON,fetchCMSJSONs} from 'system/AssetManager'
import gsap,{Power2} from 'gsap'
import classNames from 'classnames';
import Globals  from 'system/Globals';
import styles from './controller-narrative.module.css'
import nstyles from '../narrative/narrative.module.scss'
import mstyles from '../narrative/modules/modules.module.css'
import NarrativeMenuItem  from 'narrative/NarrativeMenuItem'
import ControllerServerComs from 'system/ControllerServerComs'
import ControllerJoystick from './ControllerJoystick'
import ControllerVideoUI from './ControllerVideoUI';
import {ReactComponent as Apps} from 'assets/icons/apps.svg'
import {ReactComponent as Chevron} from '../assets/icons/caret_down.svg'
import {ReactComponent as CloseButton} from '../assets/icons/close.svg'
import {ReactComponent as ChevronThinButton} from '../assets/icons/caret_right.svg'
import {ReactComponent as PlayButton} from '../assets/icons/play.svg'
import {ReactComponent as VRButton} from '../assets/icons/vr_white.svg'
import {ReactComponent as Pin} from '../assets/icons/mapbox_pin.svg'
import {ReactComponent as ZoomOut} from '../assets/icons/minus.svg'
import {ReactComponent as ZoomIn} from '../assets/icons/plus.svg'
import {ReactComponent as CaretRight} from '../assets/icons/caret_right.svg'
import {ReactComponent as CaretLeft} from '../assets/icons/caret_left.svg'
import {ReactComponent as CaretUp} from '../assets/icons/caret_up.svg'
import {ReactComponent as CaretDown} from '../assets/icons/caret_down.svg'
import {ReactComponent as Bulb} from '../assets/icons/380S-bulb.svg'
import {ReactComponent as Calendar} from "../assets/icons/calendar.svg"
import {ReactComponent as Arrow} from '../assets/icons/timeline-arrow.svg'
import {ReactComponent as FilterIcon} from '../assets/icons/timeline_filter.svg';
import {ReactComponent as Predict} from '../assets/icons/predict.svg'
// import { format, zonedTimeToUtc } from 'date-fns-tz';
import { addDays, differenceInCalendarDays, format, parseISO, getMonth, getDate, getYear, formatISO } from 'date-fns';

const ControllerTimeline = (props)=>{

    const scrollContainer = useRef();
    const timelineScrollContainer = useRef();
    const [selected,setSelected] = useState(null)
    const [selectedId, setSelectedId] = useState(null);
    const [styleMenu,setStyleMenu]=useState({})
    const [menuItems,setMenuItems] = useState([])
    const [styleMenuSelected,setStyleMenuSelected]=useState({})
    const [events, setEvents] = useState(null);
    const [activeEvent, setActiveEvent] = useState(null);
    const [filters, setFilters] = useState(null);
    const [filtersOn, setFiltersOn] = useState([]);
    const [backPageIndex, setBackPageIndex] = useState(false);
    const [showActualPredicted, setShowActualPredicted] = useState(false);

    function formatDate(apiDate){
          const parsedDate = parseISO(apiDate);
          const formatted = format(parsedDate, 'LLL dd, y');
          return formatted
        }

    const getDateDifference = (startDate, endDate) => {
        // Convert to Date objects
        const start = new Date(startDate);
        const end = new Date(endDate);
        
        // Calculate the difference in milliseconds
        const diffInMs = end - start;
        
        // Convert milliseconds to days
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        
        // Get weeks and remaining days
        const weeks = Math.floor(diffInDays / 7);
        const days = diffInDays;

        // console.log('getDateDifference', startDate, endDate, weeks, days)

        return { weeks, days };
        }

    function processParams(){
        let params = new URLSearchParams(props.params);
        let event = params.get('timeline-event');
        let filters = params.get('filters');
        console.log('processParams', event);
       if (event) {
          
            // setActiveEvent(parseInt(event));
        setTimeout(() => {
            timelineScrollContainer.current.scrollTo({
            top: document.getElementById('event_' + parseInt(event)).offsetTop - 100,
            behavior: 'smooth'
          });
        }, 300);
        
            ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-select-event', event);
            let filterParams;
            if (filtersOn.length > 0) {
                filterParams = '&filters=' + JSON.stringify(filtersOn);
            }
            props.setCurrentParams("?module=" + props.module.id + "&timeline-event=" + event + (filterParams || ''));


        }

        if (filters) {
            setFiltersOn(JSON.parse(filters));



            // ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-select-filters', filters);
        }

        props.setCurrentParams(null);

    }
    
    useEffect(()=>{
     
        console.log('timeline props', props)
        
        return () => {
        }
    },[])

    useEffect(() => {
      if (activeEvent) {
          timelineScrollContainer.current.scrollTo({
            top: document.getElementById('event_' + activeEvent).offsetTop - 100,
            behavior: 'smooth'
          });
      }

    }, [activeEvent]);

    useEffect(() => {
        if (props.reload > -1) {
            console.log('reload', props.reload)

            setSelected(null);
        }
        
    }, [props.reload])

    useEffect(() => {
      console.log('events', events, props.params)
        if (props.params) {
            processParams();
        }
    }, [props.params])

    useEffect(()=>{
        if (props.module.id) {
            // setSelected(0);
            // setActivePage(props.activeNarrativePageIndex);
            // props.setActiveNarrativePageIndex(null);
            let arrMenuItems=[]
            props.module.tags.forEach(obj=>{
                arrMenuItems.push({label:obj.text, 'id': obj.id, "name": obj.name})
            })
            setMenuItems(arrMenuItems)
            setEvents(props.module.events);

            console.log('controller timeline', props.module.files)
            setStyleMenu(Globals.instance().getThemeStyle(['nav-menu-item'],props.theme))
            setStyleMenuSelected(Object.assign({},Globals.instance().getThemeStyle(['nav-menu-item'],props.theme),{color:'var(--primary-accent)', '--hover-color': 'var(--primary-accent)'}))
            // setCategories(props.module.mapboxes)
        } 
          // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [props.module.id])

    useEffect(() => {
        if (props.module.tags && props.module.tags.length > 0) {
              let newList = [];

              props.module.tags.forEach((obj, i) => {
              let exists = newList.findIndex(a => a.id === parseInt(obj.id))
    
                if (!obj.parent && exists < 0) {
                  
                    let listObj = {
                        id: parseInt(obj.id),
                        text: obj.text,
                        children: []
                    }
                    newList.push(listObj);
    
                } else {
                  
                  let parentIndex = newList.findIndex(a => a.id === parseInt(obj.parent))
                  // console.log('parentIndex', parentIndex, obj.parent, newList)
    
                  if (parentIndex > -1) {
                    newList[parentIndex] && newList[parentIndex]['children'].push({
                      id: parseInt(obj.id),
                      text: obj.text,
                      children: []
                    });
               
                  } 
                  else {
                    let parentObj = props.module.tags.find(a => a.id === obj.parent);
                      if (parentObj){
                        let listObj = {
                          id: parentObj.id,
                          text: parentObj.text,
                          visible: null,
                          locked: null,
                          children: [{
                            id: obj.id,
                            text: obj.text,
                            children: []
                          }]
                        }
                        console.log('listObj', listObj)
                        newList.push(listObj);
                      }
                    
                      
                  }
                 
                }
    
            });
            console.log("newList", newList)
            setFilters(newList);
        }
    }, [props.module.tags]);


    useEffect(() => { 
      if (filtersOn && filtersOn.length > 0) {
        console.log('filtersOn', filtersOn)
        setTimeout(() => {
          ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-select-filters', filtersOn);
        }, 500);
         
      }
    }, [filtersOn]);

    const onEventClick = (id) =>{

        console.log('ControllerTimeline: onEventClick', id)
        if (id === activeEvent) {
            setActiveEvent(null);
        } else {
            setActiveEvent(id);
        }

        ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-select-event', id);
        // if (filter.serial_string) {
        //     onSerialCmd(filter.id, filter.serial_string);
        // }

        // if (results.length > 0) {
        //     ControllerServerComs.instance().sendUDPFromControllerToServer('module-gallery-select-file', results[0].id);
        //     onThumbnailClick(results[0].id, results[0].fileType, results[0].file, 'link')
        // }


    }   

    function onPageClick(id, page, eventId) {

      console.log('onPageClick', id, page, eventId)

      let pageIndex = props.pages.findIndex(obj=>{return obj.id === page});

        props.setCurrentModule({typeName: 'controller-narrative'});
        props.setAnimInCurrentModule(false);
        // props.setActiveNarrativePageIndex(pageIndex);
       

        console.log('props', props)
        // setSelected(null);
        // setShowLanding(true);
                
      if (pageIndex > -1) {
          props.setActivePage(props.pages[pageIndex]);
          props.setActiveNarrativePageIndex(pageIndex);

          console.log(pageIndex)
      
      }else{
          props.setActivePage(null);
      }

      console.log('params', props.params)
      let filterParams;
      if (filtersOn.length > 0) {
          filterParams = '&filters=' + JSON.stringify(filtersOn);
      }
      props.setCurrentParams("?module=" + props.module.id + "&timeline-event=" + id + (filterParams || ''));

      ControllerServerComs.instance().sendUDPFromControllerToServer('narrative-close-module');
      ControllerServerComs.instance().sendUDPFromControllerToServer('narrative-menu-link', page);
    }


    const onClickClose = () => {
        console.log('close')
        props.setPopup(false);
        if (backPageIndex) {
            onClickBack();
        }
    }


    const onZoomOut = () => {
        console.log('zoomOut') 
        ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-command', "zoom-out");
     }
 
     const onZoomIn = () => {
         console.log('zoomIn') 
         ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-command', "zoom-in");
      }

  

     const onKeyToggle = (command) => {
        console.log('onArrow', command) 
        ControllerServerComs.instance().sendUDPFromControllerToServer('key', command);
     }

     const onClickBack = () => {
        console.log('onClickBack', props.activePage) 
        props.setCurrentModule({typeName: 'controller-narrative'});
        // props.setActiveNarrativePageIndex(activePage);
        props.setAnimInCurrentModule(false);
        ControllerServerComs.instance().sendUDPFromControllerToServer('narrative-close-module');

        console.log('props', props)
        // setSelected(null);

     }



  function toggleSubs(id, e) {
     document.getElementById('caret_' + id).classList.toggle(styles.subsOff);
    document.getElementById('subs_' + id).classList.toggle(styles.subsOff);
  }

   function onFilterBtn(id) {
   setActiveEvent(null);
    let copy = [ ...filtersOn ];
    let index = copy.indexOf(id);
    if (index > -1) {
      copy.splice(index, 1)
    } else {
      copy.push(id)
      
    }
    // ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-select-filter', id);
    console.log('module-timeline-select-filter sent', id)
    setFiltersOn(copy);
  }


  function onScrollClick(direction) {
    console.log('onScrollClick', direction)
    if (direction === 'up') {
        ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-command', "up");
    } else if (direction === 'down') {
        ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-command', "down");
    }
  }

  function onClearFilters() {
    setFiltersOn([]);
    ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-clear-filters');
  }
    return (
        <React.Fragment>
           <div className={`${styles.linksContainer} ${styles.moduleLinksContainer} hide-scroller ${nstyles.galleryLinksContainer}`}>
                     
     
           {!props.showModules && <span className={nstyles.switchMenu} onClick={() => props.setShowModules(showModules => !showModules)}>
            <span className={nstyles.switchMenuBtn}><Apps /></span>
           <h4>{props.module.title}</h4></span>}

                <div className={`${styles.controllerLinks} hide-scroller`} >
          {!props.showModules && props.module && props.module.tags.length > 0 && <span className={styles.filterNavHeading}>
              <h2>Filters</h2>
              <span className={styles.pillBtn} onClick={() => onClearFilters()}>Clear All</span>
            </span>}

                            {props.module && props.module.tags && props.module.tags.length > 0 ?

         <Fragment>{<span className={styles.controllerMenuLinkRow}>
         
            <span className={styles.filterContainer}>
            {!props.showModules && filters && filters.map((obj, i) => (
              <span key={'filter' + i}>
              <span className={classNames(
                styles.filterParent,
                obj.children.length > 0 ? styles.hasChildren : styles.noChildren
              )}>
              {obj.children.length > 0 && <CaretDown id ={"caret_" + obj.id} className={styles.filterCaret} onClick={(e) => toggleSubs(obj.id, e)} />}
                <h2>{obj.text}</h2>

                {obj.children.length === 0 && <span 
                  onClick={() => onFilterBtn(obj.id)}
                  className={classNames(
                    styles.filterBox,
                    filtersOn.indexOf(obj.id) > -1 && styles.filterBoxOn
                  )}></span>}  

              </span>
              <span id={'subs_' + obj.id} className={styles.filterSubs}> 
              {obj.children && obj.children.map((obj1, i) => (
                <span key={i} className={styles.filterChild}>
                  <p>{obj1.text}</p>
                  <span 
                  onClick={() => onFilterBtn(obj1.id)}
                  className={classNames(
                    styles.filterBox,
                    filtersOn.indexOf(obj1.id) > -1 && styles.filterBoxOn
                  )}></span>  
             
                </span>
              ))}
              </span>
              </span>
            ))}
                </span>
            </span>}
        

         </Fragment>
          :
          props.module && props.module.tags.length === 0 && !props.showModules && <span className={styles.noFilters}>
          <FilterIcon />
          <h2>No Filters Yet</h2>
          <p>Once filter tags are created, you will be able to view them here</p>
        </span>
      
        }

            
            </div>
          </div>                 

            
            <section ref={scrollContainer} className={`${styles.moduleHolder}`}>

              <h2 style={{"color": "black"}}>Events</h2>

                <div ref={timelineScrollContainer} className={`${styles.timelineEvents} ${(props.showBackBtn)?styles.hasBackBtnRow:""}`}>
         
                    {events && events
                        .sort((a, b) => a.ordering - b.ordering)
                        .filter(obj => {
                            if (filtersOn.length === 0) {
                                return true;
                            } else {
                                let hasFilter = false;
                                obj.tags.forEach(tag => {
                                    if (filtersOn.indexOf(tag.id) > -1) {
                                        hasFilter = true;
                                    }
                                });
                                return hasFilter;
                            }
                        })
                        .map((obj, i) => (
                        <span key={'event_'+i} 
                        id={"event_" + obj.id}
                        className={classNames(obj.multi_day && styles.multiDayBlock, i === events.length -1 ? styles.lastEventBlock : undefined, styles.eventBlockContainer, obj.id === activeEvent && styles.eventBlockActive)}
                        // onClick={() => onEventClick(obj.id)}
                        >
                        <span className={classNames(styles.eventBlockInnerBox)}>
                    {obj.multi_day && <span 
                  className={styles.headerColor}
                  style={{backgroundColor: obj.color ? obj.color : '#555555'}}
                  ></span>}
                    <span className={classNames(styles.eventBlockContainerInner, obj.start_date_predicted && showActualPredicted && styles.eventBlockPredicted)}>
                    <span onClick={() => onEventClick(obj.id)}
                    style={{backgroundColor: obj.color && !obj.multi_day ? obj.color : '#555555'}}
                    className={
                      classNames(
                        obj.multi_day && styles.multiDay,
                        styles.eventBlock,
                        !obj.page && styles.eventBlockNoPage,
                        "ui"
                      )}>
                      <span className={styles.eventBlockBox}>
                        <span className={`flex alignCenter`}>

                        <span className="icon">
                          {obj.icon && <img src={getContentPath(obj.icon)} alt="" />}
                        </span>


                         <span className={styles.timelineHeading}>{obj.heading}</span>
                          
                          <span className="flex tags gap10">
                       
                            {obj.tags.map((tag, j) => (
                              <span className={styles.tag} key={'eventTag_' + j}>{tag.text}</span>
                            ))}

                          </span>
                        </span>

                        <span className={"flex gap5"}>
                       {obj.start_date_predicted && !obj.end_date_predicted && <span className={`flex ${styles.dateLine} gap10 alignCenter`}>
                         <Calendar /> <span>Predicted</span>
                          <strong>{formatDate(obj.start_date_predicted)}</strong>
                 
                        </span>}
                        {obj.start_date && !obj.end_date && <span className={`flex ${styles.dateLine} gap10 alignCenter`}>
                         <Calendar /> <span>Actual</span>
                         <strong>{formatDate(obj.start_date)}</strong>
                        </span>}
                        </span>
                        <span className={"flex gap5"}>
                        {obj.start_date_predicted && obj.end_date_predicted && <span className={`flex ${styles.dateLine} gap10 alignCenter`}>
                         <Calendar /> <span>Predicted</span>
                          <strong>
                          {getDateDifference(obj.start_date_predicted, obj.end_date_predicted).weeks > 0 ?
                         `${getDateDifference(obj.start_date_predicted, obj.end_date_predicted).weeks} weeks (${getDateDifference(obj.start_date_predicted, obj.end_date_predicted).days} days)`: `${getDateDifference(obj.start_date_predicted, obj.end_date_predicted).days} days`}
                         </strong>
                 
                        </span>}

                        {obj.start_date && obj.end_date && <span className={`flex ${styles.dateLine} gap10 alignCenter`}>
                        <Calendar /> <span>Actual</span>
                        <strong>
                          {getDateDifference(obj.start_date, obj.end_date).weeks > 0 ?
                         `${getDateDifference(obj.start_date, obj.end_date).weeks} weeks (${getDateDifference(obj.start_date, obj.end_date).days} days)`: `${getDateDifference(obj.start_date, obj.end_date).days} days`}
                         </strong>
                
                       </span>}
                       </span>
                          
                       

                      </span>
                         
                    </span>  
                  
                     {obj.page && (
                            <span onClick={() => onPageClick(obj.id, obj.page, "event_" + obj.id)} className={styles.eventArrow}><Arrow /></span>
                          )}

                     </span>
                    
                     </span>

                     <span className={styles.pullTabs}>
                        { obj.start_date_predicted && showActualPredicted && <span onClick={(e) => {
                          ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-show-actual', obj.id);
                          setActiveEvent(null);
                        }} className={styles.pullTab}>See <Calendar /> Actual</span>  }  

                        {obj.start_date_predicted && showActualPredicted && <span onClick={(e) => {
                          ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-show-predicted', obj.id);
                          setActiveEvent(null);
                          console.log('module-timeline-show-predicted sent', obj.id)
                        }} className={styles.pullTab}>See <Calendar /> Predicted</span>}
                      
                        </span>
                     
                    </span> 
                    ))}
                    
                </div>
                
                
                    <div className={`${styles.moduleThumbsScrollContainerGradient}`}></div>
                        <p style={{color: 'black', width:'100%', textAlign: 'center'}}>Target Device Controls</p>
                    <div className={`${styles.buttons}`}>
               

                         <div className={classNames(styles.zoomControlsContainer, styles.timelineZoomControlsContainer)}>

                        {props.module && props.module.has_predicted && <div className={`${styles.roundBtn}`} onClick={() => {
                          setShowActualPredicted(prev => !prev)
                          ControllerServerComs.instance().sendUDPFromControllerToServer('module-timeline-show-actualpredicted')
                        }}><Predict /></div>}
                      
                        <div className={classNames(styles.zoomControls, styles.timelineZoomControls, activeEvent && styles.zoomControlsActive)} >
                            <ZoomOut onClick={() => onZoomOut()} />
                            <div className={`${styles.separator}`}></div>
                            <ZoomIn onClick={() => onZoomIn()} />
                        </div>
                        
                        <div className={'flex gap10 alignCenter'}>
                            <div className={`${styles.roundBtn}`} onClick={() => onScrollClick('up')}><CaretUp /></div>
                            <div className={`${styles.roundBtn} ${styles.roundBtnRight }`} onClick={() => onScrollClick('down')}><CaretDown /></div>
                        </div>
                    
                    </div>
                </div>
            </section>
          
        </React.Fragment>
    )

}

export default ControllerTimeline
